import { Player } from '@lottiefiles/react-lottie-player'
import { Button, Grid, Typography } from '@mui/material'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import routes from '../router/routes' // import path URL object
import ErorrRobot404 from '../lottie/robot-error-404.json' // lottie animation

const PageNotFound = () => {
  const { t } = useTranslation() // Get translation function

  return (
    <Grid
      alignContent="center"
      alignItems="center"
      container
      direction="column"
      sx={{
        p: 2,
      }}
    >
      <Grid item xs={4}>
        <Player
          autoplay
          loop
          src={ErorrRobot404}
          style={{ height: '500px', width: 'auto' }}
        />
      </Grid>

      <Grid item textAlign="center" xs={6}>
        <Typography variant="h4">{t('errors.404')}</Typography>
        <Typography color="#248f24" fontWeight="bold" variant="h5">
          <br />
          {t('errors.dont_panic')}
        </Typography>
      </Grid>
      <Grid alignItems="center" item xs={6}>
        <br />
        <Button
          component={Link}
          disableElevation
          to={routes.portal.home}
          variant="contained"
        >
          {t('errors.come_back_button')}
        </Button>
      </Grid>
    </Grid>
  )
}

export default PageNotFound
